module.exports = __webpack_public_path__ + "static/media/kidFriendly.2d3f02ed.svg";